module.exports = __webpack_public_path__ + "static/media/2022_2A3A0806.b8599cd3.jpg";